
import { supabaseAnonKey } from '@/lib/supabase/client';

interface TrackOrderEventParams {
  organization_id: string;
  order_id?: string;
  product_id?: string;
  event_type: string;
  external_id?: string;
  fbc?: string;
  fbp?: string;
  event_id: string;
  custom_data?: Record<string, any>;
  shop_id?: string;
  platforms?: {
    meta?: boolean;
    google?: boolean;
    snapchat?: boolean;
    linkedin?: boolean;
    tiktok?: boolean;
  };
}

/**
 * Track an order or product event server-side using the track_event Edge Function
 * with support for multiple ad platforms
 */
export const trackOrderEvent = async (params: TrackOrderEventParams): Promise<boolean> => {
  try {
    console.log('Tracking event:', params);
    
    // URL de la fonction edge
    const edgeFunctionUrl = 'https://eledlxtrcasnxjjarfti.supabase.co/functions/v1/track_event';
    
    // Création de l'objet Headers avec le token d'authentification
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${supabaseAnonKey}`,
    });
    
    // Default platforms to send to if not specified
    const platforms = params.platforms || { meta: true };
    
    // Appel à la fonction edge
    const response = await fetch(edgeFunctionUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        ...params,
        sendToMeta: platforms.meta !== false, // Send to Meta by default if not explicitly disabled
        sendToGoogle: !!platforms.google,
        sendToSnapchat: !!platforms.snapchat,
        sendToLinkedIn: !!platforms.linkedin,
        sendToTikTok: !!platforms.tiktok
      }),
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error tracking event:', errorText);
      return false;
    }
    
    const result = await response.json();
    console.log('Tracking result:', result);
    
    // Check if any events were successfully sent
    if (result.tracking_results && result.tracking_results.length > 0) {
      const successfulCalls = result.tracking_results.filter((r: any) => r.success);
      console.log(`Successfully sent to ${successfulCalls.length} tracking platforms`);
    }
    
    return true;
  } catch (error) {
    console.error('Error in trackOrderEvent:', error);
    return false;
  }
};

/**
 * Determine which platforms to send the event to based on user status and event type
 */
export const determineTrackingPlatforms = (eventType: string) => {
  // For now we'll send to all configured platforms
  // In the future, this could conditionally enable platforms based on event type
  return {
    meta: true,
    google: true,
    snapchat: true,
    linkedin: true,
    tiktok: true
  };
};
